import { Component, Input } from '@angular/core';
import { BlogArticleDetail } from 'src/app/services/rest-api/rest-api';
import { xlDesktopWidthBreakpoint } from '../constants';

@Component({
  selector: 'libero-blog-other-articles-carousel',
  templateUrl: './blog-other-articles-carousel.component.html',
  styleUrls: ['./blog-other-articles-carousel.component.scss'],
  standalone: false
})
export class BlogOtherArticlesCarouselComponent {

  @Input() public otherPosts: BlogArticleDetail[] = [];

  public get slidesPerView(): number | 'auto' {
    if(!this.otherPosts) {
      return 'auto';
    }

    if(window.innerWidth < xlDesktopWidthBreakpoint) {
      return this.otherPosts.length > 1 ? 2 : 1;
    }

    return this.otherPosts.length > 2 ? 3 : this.otherPosts.length;
  }
}
